(function () {
  function init(root) {
    if (root.dataset.assReady) return;
    root.dataset.assReady = '1';

    var img = root.querySelector('[data-ass-fin-img]');
    var tag = root.querySelector('[data-ass-fin-tag]');
    var title = root.querySelector('[data-ass-fin-title]');
    var copy = root.querySelector('[data-ass-fin-copy]');
    root.querySelectorAll('[data-ass-finish]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-ass-finish]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        if (img && btn.dataset.src) {
          img.src = btn.dataset.src;
          img.removeAttribute('srcset');
          img.alt = 'Rustic shelf finished in ' + btn.dataset.name;
        }
        if (tag) tag.textContent = 'Shown: ' + btn.dataset.name;
        if (title) title.textContent = btn.dataset.name;
        if (copy) copy.textContent = btn.dataset.copy;
      });
    });

    var bar = root.querySelector('[data-ass-depth-bar]');
    var dTitle = root.querySelector('[data-ass-depth-title]');
    var dCopy = root.querySelector('[data-ass-depth-copy]');
    root.querySelectorAll('[data-ass-depth]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-ass-depth]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        if (bar) bar.style.width = btn.dataset.px + 'px';
        if (dTitle) dTitle.textContent = btn.dataset.title;
        if (dCopy) dCopy.textContent = btn.dataset.copy;
      });
    });

    root.querySelectorAll('[data-ass-top]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.querySelector('.product-single__meta, .product-single, main');
        (target || document.body).scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }
  function boot() { document.querySelectorAll('[data-ass]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* Extra-bracket advisor: owner rule = +1 bracket every 40cm from 120cm (1@120, 2@160 ... 5@280). */
(function () {
  function recFor(cm) { return cm >= 120 ? Math.min(5, Math.floor((cm - 80) / 40)) : 0; }
  function lengthSelect() {
    return Array.prototype.find.call(document.querySelectorAll('select'), function (s) {
      var o = Array.prototype.filter.call(s.options, function (x) { return x.value; });
      return o.length > 2 && o.every(function (x) { return /^\d+\s*cm$/i.test(x.value.trim()); });
    });
  }
  function currentLength() {
    var yes = document.querySelector('input[name^="properties[Cut to an exact size"][value="Yes"]');
    var ex = document.querySelector('input[name^="properties[Exact length"]');
    if (yes && yes.checked && ex && parseFloat(ex.value) > 0) return Math.round(parseFloat(ex.value));
    var s = lengthSelect();
    return s && s.value ? parseInt(s.value, 10) : 0;
  }
  function el(cls) { var d = document.createElement('div'); d.className = cls; return d; }
  function update() {
    var sel = document.querySelector('select[name^="properties[Extra brackets"]');
    if (!sel) return;
    var L = currentLength(), rec = recFor(L);
    var chosen = parseInt(sel.value, 10) || 0;
    var box = document.querySelector('.acumen-bracket-advice');
    if (!box) { box = el('acumen-bracket-advice'); (sel.closest('.bcpo-row, .bcpo-select, div') || sel).insertAdjacentElement('afterend', box); }
    var atcBtn = document.querySelector('form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] [type="submit"]');
    var warn = document.querySelector('.acumen-bracket-warn');
    if (!warn && atcBtn) { warn = el('acumen-bracket-warn'); atcBtn.insertAdjacentElement('beforebegin', warn); }
    if (!rec) { box.hidden = true; if (warn) warn.hidden = true; return; }
    box.hidden = false;
    var n = rec + ' extra bracket' + (rec > 1 ? 's' : '');
    if (chosen >= rec) {
      box.className = 'acumen-bracket-advice is-ok';
      box.textContent = '✓ ' + (2 + chosen) + ' brackets in total, spot on for a ' + L + 'cm shelf.';
      if (warn) warn.hidden = true;
    } else {
      box.className = 'acumen-bracket-advice';
      box.innerHTML = '';
      var t = document.createElement('span');
      t.textContent = 'For a ' + L + 'cm shelf we recommend ' + n + ' (' + (2 + rec) + ' in total). ';
      var b = document.createElement('button'); b.type = 'button'; b.textContent = 'Add ' + n;
      b.addEventListener('click', function () {
        var opt = Array.prototype.find.call(sel.options, function (o) { return parseInt(o.value, 10) === rec; });
        if (opt) { sel.value = opt.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      box.appendChild(t); box.appendChild(b);
      if (warn) { warn.hidden = false; warn.textContent = 'We recommend ' + n + ' for a ' + L + 'cm shelf. Without them it may bow over time.'; }
    }
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(update, 60); }
  document.addEventListener('change', soon, true);
  document.addEventListener('input', soon, true);
  var tries = 0, iv = setInterval(function () { update(); if (++tries > 20 || document.querySelector('.acumen-bracket-advice')) clearInterval(iv); }, 500);
})();
